import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SideDrawer from '../components/SideDrawer';
import { useAuth } from '../contexts/AuthContext';
import '../styles/CampaignAnalysis.css';
import LikeSvg from '../assets/icons/red-heart-icon.svg';
import CommentsSvg from '../assets/icons/positive-feedback-icon.svg';
import ViewsSvg from '../assets/icons/eye-icon.svg';
import { Container, Row, Col, Card, Button, CardBody } from 'react-bootstrap'
import { formatPostDate } from '../services/dateFormate';
import InstagramSvg from '../assets/icons/instagram.svg';
import TikTokSvg from '../assets/icons/tiktok-icon.svg';
// import VerifiedIcon from '../assets/icons/verified.svg';

const CampaignAnalysis = () => {
    const { isCollapsed } = useAuth();
    const location = useLocation();
    const postData = location.state?.postData || {};
    const navigate = useNavigate();

    const renderMetric = (icon, value, label) => (
        <Col xs={6} md={4} lg={3} className="mb-4">
            <div className="h-100">
                <div>
                    <div className="d-flex align-items-center">
                        {icon && 
                            <div className='metric-icon me-2'>
                                <img src={icon} alt={label} style={{ width: '18px', height: '18px' }} />
                            </div>
                        }
                        <strong>{value}</strong>
                    </div>
                    <div><small>{label}</small></div>
                </div>
            </div>
        </Col>
    );

    function formatNumber(value) {

        if (value >= 1e9) {
            return (value / 1e9).toFixed(2) + "B";
        } else if (value >= 1e6) {
            return (value / 1e6).toFixed(2) + "M";
        } else if (value >= 1e3) {
            return (value / 1e3).toFixed(2) + "K";
        } else {
            return value?.toString();
        }
    }

    function calculateEngagementRate(postData) {
        if (!postData || !postData.engagement) return "0%"; // Handle missing data
    
        const totalEngagement = 
            (postData.engagement.like_count ?? 0) + 
            (postData.engagement.comment_count ?? 0) + 
            (postData.share_count ?? 0);
    
        return postData.totalViews 
            ? ((totalEngagement / postData.totalViews) * 100).toFixed(2) + "%" 
            : "0%";
    }
    

    function calculateTotalEngagement(postData) {
        if (!postData || !postData.engagement) return 0; // Handle missing data
    
        return (postData.engagement.like_count ?? 0) + 
               (postData.engagement.comment_count ?? 0) + 
               (postData.share_count ?? 0);
    }
    

    function calculateTotalImpressions(postData) {
        return (postData.totalViews ?? 0) + calculateTotalEngagement(postData);
    }

    const handleBackClick = () => {
        navigate(-1);
      };

    return (
        <div className="campaign-analysis-dashboard App">
            <SideDrawer />
            <div className="main-container" style={{ marginLeft: isCollapsed ? '6%' : '13.6%' }}>
                <div className='campaign-analysis-main-content mx-4'>
                    <div className="d-flex align-items-center mb-4">
                        {/* Back arrow */}
                        <button 
                            onClick={handleBackClick} 
                            style={{ 
                            border: 'none', 
                            background: 'transparent', 
                            cursor: 'pointer' 
                            }}
                        >
                            {/* Inline SVG for arrow or replace with your preferred icon */}
                            <svg 
                            width="24" 
                            height="24" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            stroke="#000" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                            >
                            <line x1="20" y1="12" x2="4" y2="12" />
                            <polyline points="10 18 4 12 10 6" />
                            </svg>
                        </button>

                        {
                            postData.work_platform?.id === '9bb8913b-ddd9-430b-a66a-d74d846e6c66' && (
                                <img
                                    src={InstagramSvg}
                                    alt="Instagram"
                                    style={{ width: '32px', marginLeft: '16px', marginRight: '8px' }}
                                />
                            )
                        }
                        {
                            postData.work_platform?.id === 'de55aeec-0dc8-4119-bf90-16b3d1f0c987' && (
                                <img
                                    src={TikTokSvg}
                                    alt="TikTok"
                                    style={{ width: '32px', marginLeft: '16px', marginRight: '8px' }}
                                />
                            )
                        }


                        <div>
                            <h5 className="mb-1">
                                {postData.work_platform?.id === '9bb8913b-ddd9-430b-a66a-d74d846e6c66'
                                    ? 'Instagram reel by'
                                    : postData.work_platform?.id === 'de55aeec-0dc8-4119-bf90-16b3d1f0c987'
                                        ? 'TikTok video by'
                                        : ''}
                                {/* <img
                                    src={VerifiedIcon}
                                    alt="Verified"
                                    style={{ width: '16px', marginLeft: '6px' }}
                                /> */}
                            </h5>


                            {/* Date */}
                            <small className='fw-normal text-muted'>
                                {postData.published_at ? formatPostDate(postData.published_at) : "No Date"}
                            </small>
                        </div>
                    </div>
                    <Card className="mb-4">
                        <CardBody>
                            <Row>
                                <Col md={4}>
                                    <iframe
                                        className="w-100"
                                        height="240"
                                        src={postData.url || "https://www.youtube.com/embed/dQw4w9WgXcQ"}
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allowFullScreen
                                    ></iframe>
                                </Col>
                                <Col md={8}>
                                    <h5>{postData?.title}</h5>
                                    <p>{postData?.description || "No description available."}</p>
                                    <Row>
                                        {renderMetric(LikeSvg, formatNumber(postData.engagement?.like_count ?? 0), "Likes")}
                                        {renderMetric(CommentsSvg, formatNumber(postData.engagement?.comment_count ?? 0), "Comments")}
                                        {renderMetric(ViewsSvg, formatNumber(postData.engagement?.view_count ?? 0), "Views")}
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card className='mt-5 p-4'>
                        <h4>Performance Metrics</h4>
                        <CardBody>
                            <Row>
                                {renderMetric(null, calculateEngagementRate(postData), "Engagement Rate")}
                                {renderMetric(null, formatNumber(calculateTotalEngagement(postData)), "Total Engagement")}
                                {/* {renderMetric(null, videoData?.reach || "N/A", "Reach")} */}
                                {renderMetric(null, formatNumber(calculateTotalImpressions(postData)), "Impressions")}
                            </Row>
                        </CardBody>
                    </Card>
                    {/* <Card className="mt-4">
                        <CardBody>
                            <h3>Add post to a campaign for comment analysis data</h3>
                            <p>Comments analysis helps you understand the relevance and sentiment behind the comments of the post by using AI.</p>
                        </CardBody>
                    </Card> */}
                </div>
            </div>
        </div>
    );
};

export default CampaignAnalysis;
